// @ts-nocheck
import React, { useState } from "react";
import axios from 'axios';
import KeyCloak from "../../Auth/Keycloak";
import { AliasContext } from "./AliasContext";
import { RUTA_API_ALIAS, RUTA_API_AREAS, RUTA_API_DIFUSIONES, URL_API_SIA } from "../../Contantes/Constantes";
import { useBody } from "../../Body/state/BodyContext";
import { setupInterceptorsTo } from "../../Componentes/API/AxiosBuilder";

export function ProvideAlias({ children }) {
    const emails = useProvideAlias();


    return (
        <AliasContext.Provider value={emails}>
            {children}
        </AliasContext.Provider>
    );
}

function useProvideAlias() {
    const axiosInstance = setupInterceptorsTo(axios.create({
        headers: {
            "Content-Type": "application/json",
        },
    }));
    const { setMessage, setInfo } = useBody();
    const [load, setLoad] = React.useState(false);
    const [loadingAlias, setLoadingAlias] = useState(false);
    const [areas, setAreas] = useState([])
    const [aliases, setAliases] = useState([])
    const [patron, setPatron] = useState("")
    const [openVista, setOpenVista] = useState(false)
    const [openEditar, setOpenEditar] = useState(false)
    const [openEliminar, setOpenEliminar] = useState(false)

    const aliasInicial = {
        area: { id: '', nombre: '' },
        descripcion: '',
        destinatarios: [],
        mail: '',
        nombre: '',
        visibilidadLibreta: 0
    }
    const [alias, setAlias] = useState(aliasInicial)

    const subgrupos = (area) => {
        area.subGroups.map(sub => { mapeoAreas(sub) })
    }
    let aux = []
    const mapeoAreas = (area) => {
        if (area.subGroups != null) {
            aux.push({
                ['id']: area.id,
                ['nombre']: area.path,
            })
            subgrupos(area)
        }

        return aux;

    }

    const fetchAreas = async () => {
        const areasTreeFlatList = [];

        try {
            const areas = await getAreas();

            const fetchAllSubgrupos = async (area) => {
                areasTreeFlatList.push(area);

                if (area.subGroupCount > 0) {
                    const subgrupos = await fetchSubgrupos(area);
                    for (const subgrupo of subgrupos) {
                        subgrupo.subGroups = await fetchAllSubgrupos(subgrupo);
                    }
                    return subgrupos;
                } else {
                    return [];
                }
            };

            const areasTree = await Promise.all(
                areas.map(async (area) => {
                    area.subGroups = await fetchAllSubgrupos(area);
                    return area;
                })
            );
            setAreas(areasTreeFlatList)
        } catch (e) {
            console.error("Error al construir el árbol de áreas:", e);
            setMessage("Hubo un error al construir el árbol de áreas (Código de error: 00036)");
            return [];
        }
    };

    async function fetchSubgrupos(area) {
        try {
            const response = await axiosInstance({
                method: 'GET',
                url: `${URL_API_SIA}/areas/area/subgrupos/${area.id}`,
            });
            return response.data;
        } catch (e) {
            setMessage("Hubo un error al traer los subgrupos (Código de error : 00035)");
            console.error("Error obteniendo subgrupos:", e);
            return [];
        }
    }

    const getAreas = async () => {
        try {
            const response = await axiosInstance({
                method: 'GET',
                url: URL_API_SIA + '/areas/areas',
            });
            return response.data;
        } catch (e) {
            console.error("Error al traer las áreas:", e);
            setMessage("Hubo un error al traer las áreas (Código de error: 00033)");
        }
    };

    const fetchAlias = async (p) => {
        if (!p) return;
        setLoadingAlias(true);
        try {
            const { data } = await axiosInstance.get(`${RUTA_API_ALIAS}/mail/${p}`);
            if (data.length === 0) {
                setAliases([]);
                setInfo("No se encontraron alias con ese patrón.");
            } else {
                setAliases(data);
            }
        } catch {
            setMessage("Ocurrió un error al realizar la búsqueda.");
        } finally {
            setLoadingAlias(false);
        }
    };

    const getAlias = async (mail) => {
        try {
            const response = await axiosInstance({
                method: 'GET',
                url: `${RUTA_API_ALIAS}/mail/${mail}`,
            });
            return response.data;
        } catch (e) {
            console.error("Error al traer los datos del alias:", e);
        }
    };

    return {
        setMessage, setInfo,
        areas, setAreas,
        load, setLoad,
        alias, setAlias,
        aliases, setAliases,
        openVista, setOpenVista,
        openEditar, setOpenEditar,
        openEliminar, setOpenEliminar,
        getAlias,
        fetchAreas,
        patron, setPatron,
        fetchAlias,
        loadingAlias,
    };
}
